module.exports = __webpack_public_path__ + "img/cyton.eff3e6ff.png";